<script setup lang="ts">
import { PublicSellerFactoriesQuery } from '@gql/PublicSellerFactoriesQuery'

const t2 = useT2({})
const { handle } = useSeller('server')
const sellerId = useSellerId('retail')
const { myLink } = useLinks()

const slugV = useParams((i) => helpers.unArray(i.id))

const { ui: items } = useApolloWrap2<gen.PublicSellerFactoriesQuery, gen.PublicSellerFactoriesQueryVariables>(PublicSellerFactoriesQuery)({
  vars() {
    const _id = sellerId.value
    if (!_id) return
    return { input: { seller: { _id }, findOne: undefined } }
  },
  ui: (i) => helpers.arr(i?.publicSellerFactories),
})

const selectedDoc = computed(() => helpers.arrFindId(items.value, slugV.value, (i) => i.id))

const { ui: full } = useApolloWrap2<gen.PublicSellerFactoriesQuery, gen.PublicSellerFactoriesQueryVariables>(PublicSellerFactoriesQuery)({
  vars() {
    const slug = slugV.value
    const _id = sellerId.value
    if (!_id || !slug || selectedDoc.value) return
    return { input: { seller: { _id }, findOne: { slug } } }
  },
  ui: (i) => helpers.arr(i?.publicSellerFactories).at(0),
})

useHead({
  title: t2('Factories'),
})
// useServerHead({
//   script: [
//     seoSchema({
//       '@type': 'ItemList',
//       name: 'Our Manufacturing Factories',
//       itemListElement: [
//         {
//           '@type': 'ListItem',
//           position: 1,
//           item: {
//             '@type': 'Place',
//             name: 'Factory 1',
//             image: 'https://example.com/images/factory1.jpg',
//             address: {
//               '@type': 'PostalAddress',
//               streetAddress: '123 Industrial Way',
//               addressLocality: 'Factory City',
//               addressRegion: 'CA',
//               postalCode: '90210',
//               addressCountry: 'US',
//             },
//             telephone: '+1-800-555-1234',
//             geo: {
//               '@type': 'GeoCoordinates',
//               latitude: '34.0522',
//               longitude: '-118.2437',
//             },
//             description: 'This is our primary factory where we produce our high-quality products using sustainable practices.',
//             url: 'https://example.com/factory1',
//             sameAs: [
//               'https://www.linkedin.com/company/factory1',
//               'https://www.facebook.com/factory1',
//             ],
//           },
//         },
//         {
//           '@type': 'ListItem',
//           position: 2,
//           item: {
//             '@type': 'Place',
//             name: 'Factory 2',
//             image: 'https://example.com/images/factory2.jpg',
//             address: {
//               '@type': 'PostalAddress',
//               streetAddress: '456 Manufacturing Lane',
//               addressLocality: 'Production City',
//               addressRegion: 'TX',
//               postalCode: '73301',
//               addressCountry: 'US',
//             },
//             telephone: '+1-800-555-5678',
//             geo: {
//               '@type': 'GeoCoordinates',
//               latitude: '30.2672',
//               longitude: '-97.7431',
//             },
//             description: 'At Factory 2, we specialize in large-scale production with cutting-edge machinery.',
//             url: 'https://example.com/factory2',
//             sameAs: [
//               'https://www.instagram.com/factory2',
//             ],
//           },
//         },
//       ],
//     }),
//   ],
// })
</script>

<template>
  <InfoPage
    :title="t2('Factories')"
    :full="selectedDoc || full"
    :items="items"
    :slug="slugV"
    :ui="
      (i) => ({
        id: i.id,
        image: i.image,
        title: i.title.value,
        to: handle ? myLink('info-factory-id', { id: i.id }) : undefined,
      })
    "
    :back="handle ? myLink('info-factory', {}) : undefined"
    :fullui="(i) => ({ documentId: i.document?._id, image: i.image, title: i.title.value, slugMath: i.id })"
  >
    <!-- myLink('@seller-info-factory-id', { id: i.id, seller: handle }) -->
    <!-- handle ? myLink('@seller-info-factory', { seller: handle }) : undefined -->
    <template #default="{ item }">
      <UiLine :label="t2('Location')" :value="item?.location?.value" />
    </template>

    <template #full="{ item }">
      <h4 v-if="item?.location?.value">{{ item?.location?.value }}</h4>
    </template>
  </InfoPage>
</template>
